import { NgModule } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { CominicationComponent } from './cominication.component';



@NgModule({
  declarations: [
    CominicationComponent
  ],
  imports: [
    FormlyModule.forRoot({
      validationMessages:[
        { name: 'required', message: 'El campo es requerido' }
      ],
      validators: [
        { name: 'requiredTrue', validation: Validators.requiredTrue },
      ]
    }),
    FormlyMaterialModule,
    ReactiveFormsModule
  ],
  exports: [
    CominicationComponent
  ]
})
export class CominicationModule { }
